import React, { useEffect, useState } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import LeftPanel from "../include/leftpanel";
import axios from "axios";
import Global from "../../APIConfig";
import AuthUser from "../../AuthUser";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { useNavigate } from "react-router-dom";


function Generatepickupscheduleagent()
{

    const navigate = useNavigate();
        const [agentlist, setAgentlist] = useState([]);
        const [userdata, setUserdata] = useState({});
        const {headers1,headers2,logout}=AuthUser();
        const [selectedAgent, setSelectedAgent] = useState('');
        const [agnetid, setAgentid] = useState('');
        const [consignments, setConsignments] = useState(''); 
        const [totalweight, setTotalweight] = useState('');
        const [destination, setDestination] = useState(''); 
        const [product_Type, setProduct_Type] = useState('Document'); // Default to Document
        const [pickupDate, setPickupDate] = useState(getTodayDateString());
        const [pickupAddressSelected, setPickupAddressSelected] = useState('');
        const [warehouselist, setWarehouselist] = useState([]);
         const [currentTime, setCurrentTime] = useState(new Date());
        const formattedTime = currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    
        useEffect(()=>{
            GetAgentlist();
            const items = JSON.parse(localStorage.getItem('user'));
            if (items) {
                setUserdata(items);
            }
            const timerId = setInterval(() => {
                setCurrentTime(new Date());
            }, 10000);
            return () => clearInterval(timerId);
        },[]);
        
        function getTodayDateString() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
          }
        const handleTimeChange = (e) => {
            const [hours, minutes] = e.target.value.split(':');
            const newTime = new Date(currentTime);
            newTime.setHours(hours, minutes);
            setCurrentTime(newTime);
        };
        
         const GetAgentlist=()=>{
                axios({
                    method: 'post',
                    url: Global.baseUrl+'GetAgentList',
                    headers:headers1,
                    
                })
                .then(function (response) {
                    console.log("///////////",response.data);
                    console.log(response.data);
                    if(response.data.status == 200)
                    {
                        setAgentlist(response.data.value);
                    }
                    else
                    {
                        setAgentlist([]);
                    }
                })
                .catch(function (error) {
                    if(error.response.status==401){
                        toast.error(error.response.statusText);
                        logout();
                        navigate('/');
                        window.location.reload();
                    }
                    // console.log(error);
                });
            }
    
             const GetwarehousebyAgentid=(id)=>{
                axios({
                    method: 'post',
                    url: Global.baseUrl+'AdminWarehouseList',
                    headers:headers1,
                    data: {
                        cust_id: id
                    }
                })
                .then(function (response) {
                    if(response.data.status == 200)
                    {
                        setWarehouselist(response.data.value);
                    }
                    else
                    {
                        setWarehouselist([]);
                    }
                })
                .catch(function (error) {
                    if(error.response.status==401){
                        toast.error(error.response.statusText);
                        logout();
                        navigate('/');
                        window.location.reload();
                    }
                    // console.log(error);
                });
            }
    
            const filterBy = (option, state)=> {
            if (state.selected.length) {
              return true;
            }
            return option.label.toLowerCase().indexOf(state.text.toLowerCase()) > -1;
          }
    
          const handelAgentid=(e)=>{
            const id = e[0].value;
            const name = e[0].label;
            setSelectedAgent(name)
            setAgentid(id);
            GetwarehousebyAgentid(id);
        }
    
        const submit=()=>{
            if(agnetid == '' || selectedAgent == '')
            {
                toast.error("Please select a agent"); 
                return;
            }
            if(consignments == '')
            {
                toast.error("Please enter consignment numbers");
                return;
            }
            if(totalweight == '')
            {
                toast.error("Please enter total expected weight");
                return;
            }
            if(destination == '')
            {
                toast.error("Please enter destination details");
                return;
            }
            if(pickupAddressSelected == '')
            {
                toast.error("Please select a pickup address");
                return;
            }
            if(pickupDate == '')
            {
                toast.error("Please select a pickup date");
                return;
            }
            if(formattedTime == '')
            {
                toast.error("Please select a pickup time");
                return;
            }
            axios({
                method: 'post',
                url: Global.baseUrl+'GeneratePickupRunSheetAgent',
                headers:headers2,
                data: {
                    customerid: agnetid,
                    consignments: consignments,
                    totalweight: totalweight,
                    destination: destination,
                    product_Type: product_Type,
                    pickupDate: pickupDate,
                    pickupTime: formattedTime,
                    warehouseid: pickupAddressSelected
                }
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    toast.success(response.data.message);
                    setTimeout(() => {
                        navigate('/ScheduledPickupList/All');
                        window.location.reload();
                    }, 1000);
                }
                else if(response.data.status == 500)
                {
                    toast.error(response.data.message);
                }
            })
            .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
            });
        }


    return(
        <>
        <LeftPanel/>
            <main className='home-section'>
            <Header/>
            <ToastContainer/>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                            <li className="breadcrumb-item">
                                <a href="/Admin-Dash">
                                <i className="bx bx-home text-primary-400 fs-6"></i>
                                </a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Pick Run Sheet</li>
                        </ol>
                    </nav>
                    <div className="d-flex justify-content-between">
                        <div className="">
                            <button className="btn btn_nav btn-sm" type="button" onClick={() => navigate(-1)}>
                            <i className="bx bx-arrow-back "></i>
                            </button>
                        </div>
                        <div className="ps-2 ">
                            <h2 className="h4">Schedule New Agent PRS</h2>
                        </div>
                    </div>
                </div>
                
                <div className="btn-toolbar mb-2 mb-md-0">
                </div>
            </div>
             <div className="row justify-content-between">
                            <div className="col-12 col-md-6">
                                <div className="card mb-3">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12 col-md-12 mb-3">
                                                <div><label htmlFor="email" className="form-label">Select Agent: <span className="text-danger">*</span></label></div>
                                                <Typeahead
                                                    filterBy={filterBy}
                                                    id="toggle-example1"
                                                    options={agentlist}
                                                    placeholder="Choose a agent..."
                                                    onChange={handelAgentid}
                                                />
                                            </div>
                                            <div className="col-12 col-md-6 mb-3">
                                                <div><label htmlFor="email" className="form-label">No. of Consignments: <span className="text-danger">*</span></label></div>
                                                <input type="text" className="form-control" id="text" placeholder="Enter consignment numbers" onChange={(e)=>setConsignments(e.target.value)} />
                                            </div>
                                            <div className="col-12 col-md-6 mb-3">
                                                <div><label htmlFor="email" className="form-label">Total Weight: <span className="text-danger">*</span></label></div>
                                                <input type="text" className="form-control" id="text" placeholder="Enter total expected" onChange={(e)=>setTotalweight(e.target.value)} />
                                            </div>
                                            <div className="col-12 col-md-12 mb-3">
                                                <div><label htmlFor="email" className="form-label">Destination Description: <span className="text-danger">*</span></label></div>
                                                <input type="text" className="form-control" id="text" placeholder="Enter location details" onChange={(e)=>setDestination(e.target.value)} />
                                            </div>
                                            <div className="col-12 col-md-12 mb-3">
                                                <div><label htmlFor="email" className="form-label">Item Type: <span className="text-danger">*</span></label></div>
                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="radio" id="Parcel" checked={product_Type == 'Parcel'} onChange={()=>setProduct_Type('Parcel')}/>
                                                    <label className="form-check-label" htmlFor="inlineRadio1">Document</label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="radio" id="Document" checked={product_Type == 'Document'} onChange={()=>setProduct_Type('Document')}/>
                                                    <label className="form-check-label" htmlFor="inlineRadio2">Parcel</label>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6 mb-3">
                                                <div><label htmlFor="email" className="form-label">Date for Pickup: <span className="text-danger">*</span></label></div>
                                                <input type="date" className="form-control" placeholder="Date" value={pickupDate} onChange={(e)=>setPickupDate(e.target.value)} />
                                            </div>
                                            <div className="col-12 col-md-6 mb-3">
                                                <div><label htmlFor="email" className="form-label">Time for Pickup: <span className="text-danger">*</span></label></div>
                                                <input type="time" className="form-control" placeholder="Time" value={formattedTime} onChange={handleTimeChange} />
                                            </div>
                                            <div className="col-12 col-md-6 mb-3">
                                                <div className="d-flex justify-content-between">
                                                    <div ><label htmlFor="email" className="form-label">Pickup Address: <span className="text-danger">*</span></label></div>
                                                </div>
                                                <select className="form-select" onChange={(e)=>setPickupAddressSelected(e.target.value)} value={pickupAddressSelected}>
                                                <option value="">-- Please Select --</option>
                                                {warehouselist.map((item, index) => (
                                                    <option key={index} value={item.unique_id}>{item.warehouseName}</option>
                                                ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
            
                        <div className="">
                            <button className="btn btn-primary" onClick={submit}>Generate Pickup Run Sheet</button>
                        </div>
            <Footer/>
            </main>
        </>
    );
}
export default Generatepickupscheduleagent;